import styled from "styled-components";
import { motion } from "framer-motion";

export const ContianerTurnosRecepcionadosLabo = styled(motion.div)`
  width: 100vw;
  height: calc(100vh - 160px);
  display: flex;
  text-align: center;
  align-items: center;
  flex-direction: column;
  overflow-y: scroll;
  padding: 20px 0;
  gap: 20px;
`;
